import React, { useState } from "react";
import t from "../service/translate.service";
import { useTheme } from "../providers/ThemeProvider";

export const VerificationModal = ({ isOpen, onClose }) => {
  const [visible, setVisible] = useState(isOpen);
  const { magnifyText } = useTheme();

  const handleClose = () => {
    setVisible(false);
    onClose();
  };

  if (!visible) return null;

  const styles = {
    overlay: {
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    modal: {
      backgroundColor: 'white',
      width: '500px',
      padding: '20px',
      borderRadius: '8px',
      boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
      position: 'relative',
      textAlign: 'center',
    },
    closeButton: {
      marginTop: '20px',
      padding: '10px 20px',
      fontSize: `${magnifyText(16)}px`,
      cursor: 'pointer',
      border: 'none',
      backgroundColor: '#50b996',
      color: 'white',
      borderRadius: '4px',
      transition: 'background-color 0.3s',
    },
    content: {
      color: 'black',
      fontSize: `${magnifyText(16)}px`,
    },
  };

  return (
    <div style={styles.overlay} aria-live="polite">
      <div style={styles.modal}>
        <p style={styles.content} aria-describedby="thank-you-message">
          {t.CONTRACT_VERIF_THANK_YOU}
        </p>
        <button
          style={styles.closeButton}
          onClick={handleClose}
          aria-label={t.CONTRACT_VERIF_CONTINUE}
        >
          {t.CONTRACT_VERIF_CONTINUE}
        </button>
      </div>
    </div>
  );
};
